import styles from './member.module.css';
import Hero from './hero/hero';
import FullHero from './hero/fullHero';
import MediumHero from './hero/mediumHero';
import NumberOfResponses from './numberOfResponses/numberOfResponses';

const Member = () => {
    return (
        <div className={styles.memberContainer}>
            <MediumHero 
                imageUrl="https://images.unsplash.com/photo-1616963248328-6b7bea589840" 
                altText="Súkklumynd"
            />
            <h2>Vís undirtøku</h2>
            <p>Okkara ávirkan vigar meir, jú fleiri fólk vísa okkum undirtøku. Tí heita vit á teg um at vísa okkum undirtøku við at skriva í teigarnar niðanfyri.</p>
            <p>Umframt at vísa okkum undirtøku, hevur tú eisini møguleika at melda teg til tíðindabrævið, har tú fært kunning um:</p>
            <ul>
                <li>tiltøk so sum <a href="https://www.facebook.com/hjolvelting/" target='_blank'>Hjólvelting</a></li>
                <li>fokusøkir so sum ferðslulógin</li>
                <li>undirskriftainnsavningar</li>   
            </ul>

            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdOlvMzNGC3Jg61YqHQQzVAZ6jndQz9Gb1Gom1G0RMUv5HPPg/viewform?entry.437896319=Ja&embedded=true" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
        </div>
    );
};

export default Member;
